import { FC } from "react";
import OrderOptimizerTaxiDetailsShowDrivingRouteComponent from "./elements/order-optimizer-taxi-details-show-driving-route.component";
import OrderOptimizerTaxiDetailsItem from "../common/types/order-optimizer-taxi-details-item";

type OrderOptimizerTaxiDetailsToolsProps = {
  details?: OrderOptimizerTaxiDetailsItem;
  isDriverSelected: boolean;
  isButtonClicked: boolean;
  handleAddHomeMapMarker: () => void;
};

const OrderOptimizerTaxiDetailsToolsComponent: FC<
  OrderOptimizerTaxiDetailsToolsProps
> = (props) => {
  return (
    <div className="order_optimizer_taxi_details_tools">
      <OrderOptimizerTaxiDetailsShowDrivingRouteComponent
        details={props.details!}
        onSuccess={props.handleAddHomeMapMarker}
        isButtonClicked={props.isButtonClicked}
        idDisabled={!props.isDriverSelected}
      />
    </div>
  );
};

export default OrderOptimizerTaxiDetailsToolsComponent;
